"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard3(require("react"));
var _Wapp = require("wapplr-react/dist/common/Wapp");
var _clsx11 = _interopRequireDefault(require("clsx"));
var _externalContext = _interopRequireDefault(require("common-components/dist/common/components/App/externalContext"));
var _context8 = _interopRequireDefault(require("default-app/dist/common/components/Artwork/context"));
var _context9 = _interopRequireDefault(require("common-components/dist/common/components/Post/context"));
var _context10 = _interopRequireDefault(require("common-components/dist/common/components/App/context"));
var _withDataChange = _interopRequireDefault(require("default-app/dist/common/components/Artwork/withDataChange"));
var _getUtils = require("./getUtils");
var _getAR = _interopRequireDefault(require("./getAR"));
var style = require("./style_css.js")["default"];
function getPackages() {
  return _getPackages.apply(this, arguments);
}
function _getPackages() {
  _getPackages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7() {
    var THREE, postprocessing, _yield$import, LineMaterial, _yield$import2, Line2, _yield$import3, LineSegmentsGeometry, _yield$import4, OBJLoader, _yield$import5, FontLoader, _yield$import6, TextGeometry, _yield$import7, SVGRenderer, _yield$import8, OrbitControls;
    return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three"));
          });
        case 2:
          THREE = _context7.sent;
          _context7.next = 5;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("postprocessing"));
          });
        case 5:
          postprocessing = _context7.sent;
          _context7.next = 8;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/lines/LineMaterial.js"));
          });
        case 8:
          _yield$import = _context7.sent;
          LineMaterial = _yield$import.LineMaterial;
          _context7.next = 12;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('three/examples/jsm/lines/Line2.js'));
          });
        case 12:
          _yield$import2 = _context7.sent;
          Line2 = _yield$import2.Line2;
          _context7.next = 16;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/lines/LineSegmentsGeometry.js"));
          });
        case 16:
          _yield$import3 = _context7.sent;
          LineSegmentsGeometry = _yield$import3.LineSegmentsGeometry;
          _context7.next = 20;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/loaders/OBJLoader.js"));
          });
        case 20:
          _yield$import4 = _context7.sent;
          OBJLoader = _yield$import4.OBJLoader;
          _context7.next = 24;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/loaders/FontLoader.js"));
          });
        case 24:
          _yield$import5 = _context7.sent;
          FontLoader = _yield$import5.FontLoader;
          _context7.next = 28;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/geometries/TextGeometry.js"));
          });
        case 28:
          _yield$import6 = _context7.sent;
          TextGeometry = _yield$import6.TextGeometry;
          _context7.next = 32;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/renderers/SVGRenderer.js"));
          });
        case 32:
          _yield$import7 = _context7.sent;
          SVGRenderer = _yield$import7.SVGRenderer;
          _context7.next = 36;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/controls/OrbitControls.js"));
          });
        case 36:
          _yield$import8 = _context7.sent;
          OrbitControls = _yield$import8.OrbitControls;
          return _context7.abrupt("return", {
            THREE: THREE,
            postprocessing: postprocessing,
            LineMaterial: LineMaterial,
            Line2: Line2,
            LineSegmentsGeometry: LineSegmentsGeometry,
            OBJLoader: OBJLoader,
            FontLoader: FontLoader,
            TextGeometry: TextGeometry,
            SVGRenderer: SVGRenderer,
            OrbitControls: OrbitControls
          });
        case 39:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _getPackages.apply(this, arguments);
}
function GetPackages(props) {
  var externalContext = (0, _react.useContext)(_externalContext["default"]);
  var _externalContext$exte = externalContext.externalSettings,
    externalSettings = _externalContext$exte === void 0 ? {} : _externalContext$exte;
  var _useState = (0, _react.useState)(externalSettings.packages),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    packages = _useState2[0],
    _setPackages = _useState2[1];
  function setPackages() {
    return _setPackages2.apply(this, arguments);
  }
  function _setPackages2() {
    _setPackages2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
      var packages;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getPackages();
          case 2:
            packages = _context.sent;
            _context.next = 5;
            return _setPackages(packages);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _setPackages2.apply(this, arguments);
  }
  (0, _react.useEffect)(function () {
    if (!packages) {
      setPackages();
    }
  }, [packages]);
  return packages ? /*#__PURE__*/_react["default"].createElement(Canvas, Object.assign({}, props, {
    packages: packages
  })) : null;
}
function Canvas(props) {
  var _compositions$composi;
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var appContext = (0, _react.useContext)(_context10["default"]);
  var externalContext = (0, _react.useContext)(_externalContext["default"]);
  var _externalContext$exte2 = externalContext.externalSettings,
    externalSettings = _externalContext$exte2 === void 0 ? {} : _externalContext$exte2;
  var randomFunction = externalSettings.randomFunction;
  var params = externalSettings.params;
  var wapp = context.wapp;
  wapp.styles.use(style);
  var container = (0, _react.useRef)();
  var canvasBackgroundContainer = (0, _react.useRef)();
  var effects = (0, _react.useRef)();
  var composition = (0, _react.useRef)();
  var arContainer = (0, _react.useRef)();
  var artworkContext = (0, _react.useContext)(_context8["default"]);
  var postContext = (0, _react.useContext)(_context9["default"]);
  var post = postContext.post;
  var fullPage = props.fullPage,
    parentContainer = props.parentContainer,
    renderType = props.renderType,
    removeBackground = props.removeBackground,
    cameraZoom = props.cameraZoom,
    enableAnimation = props.enableAnimation,
    editor = props.editor,
    _props$disableFirstAn = props.disableFirstAnimation,
    disableFirstAnimation = _props$disableFirstAn === void 0 ? editor : _props$disableFirstAn,
    _props$disableChangeO = props.disableChangeObjectsAnimation,
    disableChangeObjectsAnimation = _props$disableChangeO === void 0 ? editor : _props$disableChangeO,
    _props$disableFirstRu = props.disableFirstRunAnimation,
    disableFirstRunAnimation = _props$disableFirstRu === void 0 ? editor : _props$disableFirstRu,
    _props$disableChangeO2 = props.disableChangeObjectsRunAnimation,
    disableChangeObjectsRunAnimation = _props$disableChangeO2 === void 0 ? editor : _props$disableChangeO2,
    enableAnimationKeys = props.enableAnimationKeys,
    useDataChange = props.useDataChange,
    index = props.index,
    packages = props.packages,
    onComplete = props.onComplete,
    progressRef = props.progressRef,
    controlsRef = props.controlsRef,
    snackRef = props.snackRef,
    className = props.className;
  var THREE = packages.THREE;
  var utils = (0, _getUtils.getUtils)({
    THREE: THREE,
    randomFunction: randomFunction,
    params: params
  });
  var generateCompositions = utils.generateCompositions,
    generateRenderProps = utils.generateRenderProps,
    selectObject = utils.selectObject,
    updateComposition = utils.updateComposition,
    onKeyDown = utils.onKeyDown,
    cameraMoveByControls = utils.cameraMoveByControls,
    init = utils.init,
    updateRenderers = utils.updateRenderers,
    threeJsObject = utils.threeJsObject,
    getInitialCompositions = utils.getInitialCompositions;
  var compositionsString = JSON.stringify(getInitialCompositions({
    artworkContext: artworkContext,
    generateCompositions: generateCompositions,
    externalSettings: externalSettings,
    generateRenderProps: generateRenderProps
  }));
  var compositions = (0, _react.useMemo)(function () {
    return getInitialCompositions({
      artworkContext: artworkContext,
      generateCompositions: generateCompositions,
      externalSettings: externalSettings,
      generateRenderProps: generateRenderProps
    });
  }, [compositionsString]);
  var _useState3 = (0, _react.useState)(typeof index === "number" && index >= 0 && compositions[index] ? index : 0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    compositionIndex = _useState4[0],
    _setCompositionIndex = _useState4[1];
  var initialSplitScreen = typeof props.splitScreen == "boolean" ? props.splitScreen : false;
  if (compositions[compositionIndex] && (_compositions$composi = compositions[compositionIndex].splitScreen) !== null && _compositions$composi !== void 0 && _compositions$composi.startWithSplitScreen) {
    initialSplitScreen = true;
  }
  var _useState5 = (0, _react.useState)(initialSplitScreen),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    splitScreen = _useState6[0],
    _setSplitScreen = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    forceUpdateN = _useState8[0],
    _forceUpdate = _useState8[1];
  function setSplitScreen(_x) {
    return _setSplitScreen2.apply(this, arguments);
  }
  function _setSplitScreen2() {
    _setSplitScreen2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(value) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(threeJs.splitScreen !== value)) {
              _context2.next = 7;
              break;
            }
            threeJs.waitForChangeSplitScreen = new Promise(function (resolve) {
              threeJs.waitForChangeSplitScreenResolve = function () {
                resolve();
                threeJs.waitForChangeSplitScreenResolve = null;
                threeJs.waitForChangeSplitScreen = null;
              };
            });
            threeJs.lastSplitScreen = threeJs.splitScreen;
            threeJs.splitScreen = value;
            if (typeof window !== "undefined" && window.timeWeb) {
              updateRenderers({
                threeJs: threeJs,
                disableFirstRunAnimation: disableFirstRunAnimation,
                disableChangeObjectsRunAnimation: disableChangeObjectsRunAnimation
              });
              if (container.current) {
                container.current.className = (0, _clsx11["default"])(style.canvas, (0, _defineProperty2["default"])({}, style.fullPage, fullPage), (0, _defineProperty2["default"])({}, style.splitScreen, threeJs.splitScreen), (0, _defineProperty2["default"])({}, style.editor, editor), (0, _defineProperty2["default"])({}, style.firstRender, firstRender), (0, _defineProperty2["default"])({}, className, className));
              }
            } else {
              _setSplitScreen(value);
            }
            _context2.next = 7;
            return threeJs.waitForChangeSplitScreen;
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _setSplitScreen2.apply(this, arguments);
  }
  function toggleSplitScreen() {
    return _toggleSplitScreen.apply(this, arguments);
  }
  function _toggleSplitScreen() {
    _toggleSplitScreen = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return setSplitScreen(!threeJs.splitScreen);
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _toggleSplitScreen.apply(this, arguments);
  }
  function forceUpdate() {
    return _forceUpdate2.apply(this, arguments);
  }
  function _forceUpdate2() {
    _forceUpdate2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _forceUpdate(threeJs.forceUpdateN + 1);
          case 2:
            threeJs.forceUpdateN = threeJs.forceUpdateN + 1;
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _forceUpdate2.apply(this, arguments);
  }
  function setCompositionIndex(_x2) {
    return _setCompositionIndex2.apply(this, arguments);
  }
  function _setCompositionIndex2() {
    _setCompositionIndex2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(value) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            threeJs.lastCompositionIndex = threeJs.compositionIndex;
            threeJs.compositionIndex = value;
            _context5.next = 4;
            return _setCompositionIndex(value);
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _setCompositionIndex2.apply(this, arguments);
  }
  function nextCompositionIndex() {
    return _nextCompositionIndex.apply(this, arguments);
  }
  function _nextCompositionIndex() {
    _nextCompositionIndex = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6() {
      var compositionIndex, newIndex;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            compositionIndex = threeJs.compositionIndex;
            newIndex = compositions[compositionIndex + 1] ? compositionIndex + 1 : 0;
            if (!(typeof window !== "undefined" && window.timeWeb)) {
              _context6.next = 8;
              break;
            }
            threeJs.lastCompositionIndex = compositionIndex;
            threeJs.compositionIndex = newIndex;
            updateComposition({
              compositions: compositions,
              compositionIndex: newIndex,
              threeJs: threeJs,
              toggleSplitScreen: toggleSplitScreen,
              editor: editor,
              disableChangeObjectsRunAnimation: disableChangeObjectsRunAnimation,
              cameraZoom: cameraZoom,
              disableFirstRunAnimation: disableFirstRunAnimation,
              enableAnimationKeys: enableAnimationKeys,
              disableFirstAnimation: disableFirstAnimation,
              disableChangeObjectsAnimation: disableChangeObjectsAnimation,
              setSplitScreen: setSplitScreen,
              initialSplitScreen: initialSplitScreen,
              onComplete: onComplete,
              nextCompositionIndex: nextCompositionIndex,
              selectObject: selectObject
            });
            _context6.next = 15;
            break;
          case 8:
            if (!(newIndex === compositionIndex)) {
              _context6.next = 13;
              break;
            }
            _context6.next = 11;
            return forceUpdate();
          case 11:
            _context6.next = 15;
            break;
          case 13:
            _context6.next = 15;
            return setCompositionIndex(newIndex);
          case 15:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _nextCompositionIndex.apply(this, arguments);
  }
  var threeJs = (0, _react.useMemo)(function () {
    return threeJsObject({
      wapp: wapp,
      appContext: appContext,
      setCompositionIndex: setCompositionIndex,
      setSplitScreen: setSplitScreen,
      forceUpdate: forceUpdate,
      compositionIndex: compositionIndex,
      forceUpdateN: forceUpdateN,
      packages: packages,
      splitScreen: splitScreen,
      artworkContext: artworkContext,
      renderType: renderType,
      parentContainer: parentContainer,
      container: container,
      canvasBackgroundContainer: canvasBackgroundContainer,
      effects: effects,
      enableAnimation: enableAnimation,
      removeBackground: removeBackground,
      editor: editor,
      cameraZoom: cameraZoom,
      compositions: compositions,
      progressRef: progressRef,
      controlsRef: controlsRef,
      snackRef: snackRef,
      post: post
    });
  }, []);
  useDataChange(function (payload) {
    var newCompositions = payload.value.compositions || [];
    if (JSON.stringify(newCompositions) !== compositionsString) {
      forceUpdate();
    }
  });
  (0, _react.useEffect)(function () {
    if (!compositions[compositionIndex]) {
      var newCompositionIndex = compositions[compositionIndex - 1] ? compositionIndex - 1 : 0;
      setCompositionIndex(newCompositionIndex);
    }
  }, [compositionsString, forceUpdateN, compositionIndex]);
  (0, _react.useEffect)(function () {
    return onKeyDown({
      externalSettings: externalSettings,
      editor: editor,
      threeJs: threeJs,
      compositions: compositions,
      compositionIndex: compositionIndex,
      artworkContext: artworkContext,
      setCompositionIndex: setCompositionIndex,
      forceUpdate: forceUpdate,
      cameraMoveByControls: cameraMoveByControls,
      setSplitScreen: setSplitScreen,
      splitScreen: splitScreen,
      selectObject: selectObject
    });
  }, [compositionIndex, forceUpdateN, compositionsString, splitScreen]);
  (0, _react.useEffect)(function () {
    if (wapp.target !== "node") {
      packages.AR = (0, _getAR["default"])({
        packages: packages
      });
    }
    return init({
      wapp: wapp,
      threeJs: threeJs,
      canvasBackgroundContainer: canvasBackgroundContainer,
      container: container,
      effects: effects,
      composition: composition,
      arContainer: arContainer,
      editor: editor,
      selectObject: selectObject,
      style: style
    });
  }, []);
  (0, _react.useEffect)(function () {
    return updateRenderers({
      threeJs: threeJs,
      disableFirstRunAnimation: disableFirstRunAnimation,
      disableChangeObjectsRunAnimation: disableChangeObjectsRunAnimation
    });
  }, [splitScreen]);
  (0, _react.useEffect)(function () {
    updateComposition({
      compositions: compositions,
      compositionIndex: compositionIndex,
      threeJs: threeJs,
      toggleSplitScreen: toggleSplitScreen,
      editor: editor,
      disableChangeObjectsRunAnimation: disableChangeObjectsRunAnimation,
      cameraZoom: cameraZoom,
      disableFirstRunAnimation: disableFirstRunAnimation,
      enableAnimationKeys: enableAnimationKeys,
      disableFirstAnimation: disableFirstAnimation,
      disableChangeObjectsAnimation: disableChangeObjectsAnimation,
      setSplitScreen: setSplitScreen,
      initialSplitScreen: initialSplitScreen,
      onComplete: onComplete,
      nextCompositionIndex: nextCompositionIndex,
      selectObject: selectObject
    });
  }, [compositionIndex, forceUpdateN, compositionsString]);
  var firstRender = !container.current || wapp.getTargetObject() === "node";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx11["default"])(style.canvas, (0, _defineProperty2["default"])({}, style.fullPage, fullPage), (0, _defineProperty2["default"])({}, style.splitScreen, splitScreen), (0, _defineProperty2["default"])({}, style.editor, editor), (0, _defineProperty2["default"])({}, style.firstRender, firstRender), (0, _defineProperty2["default"])({}, className, className)),
    ref: container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.center
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.canvasBackgroundContainer,
    ref: canvasBackgroundContainer
  }, /*#__PURE__*/_react["default"].createElement("canvas", {
    className: style.fullBg
  }), /*#__PURE__*/_react["default"].createElement("canvas", {
    className: style.renderer
  }), /*#__PURE__*/_react["default"].createElement("canvas", {
    className: style.renderer2
  }), /*#__PURE__*/_react["default"].createElement("canvas", {
    className: style.renderer3
  }), /*#__PURE__*/_react["default"].createElement("canvas", {
    className: style.renderer4
  })), editor ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.axis
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.effects,
    ref: effects
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx11["default"])(style.renderer, style.ar),
    ref: arContainer
  }), /*#__PURE__*/_react["default"].createElement("canvas", {
    className: style.composition,
    ref: composition
  })));
}
var _default = (0, _withDataChange["default"])(GetPackages);
exports["default"] = _default;